import React, { useEffect, useState } from "react";
import axios from "axios";
import "../SellerNotifications/SellerNotifications.css";
import notifyIcon from "../../assets/cart-notification.jpg";
import SellerServicesUrl from "../../SellerServicesUrl";
import { BaseUrl } from "../../App";

export default function SellerNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [deletingId, setDeletingId] = useState(null);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");

    return {
      Authorization: `Bearer ${token}`,
    };
  };

  async function getNotifications() {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const res = await axios.get(
        BaseUrl + SellerServicesUrl.GetSellerNotifications,
        {
          headers: getAuthHeaders(),
        }
      );

      console.log(" NOTIFICATIONS RESPONSE:", res.data);

      setNotifications(res.data.data || []);
    } catch (err) {
      console.log("❌ NOTIFICATIONS ERROR:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }

  async function getCount() {
    const token = localStorage.getItem("token");

    if (!token) {
console.log("❌ User not authenticated");
      return;
    }

    try {
      const res = await axios.get(
        BaseUrl + SellerServicesUrl.GetSellerCountNotification,
        {
          headers: getAuthHeaders(),
        }
      );

      console.log("✅ COUNT RESPONSE:", res.data);

      setCount(res.data?.data?.unread_count || 0);
    } catch (err) {
      console.log("❌ COUNT ERROR:", err.response?.data || err.message);
    }
  }

  async function markAllAsRead() {
    const token = localStorage.getItem("token");

    if (!token) return;

    try {
      const res = await axios.get(
        BaseUrl + SellerServicesUrl.GetSellerReadNotification,
        {
          headers: getAuthHeaders(),
        }
      );

      console.log("✅ READ ALL RESPONSE:", res.data);

      await getNotifications();
      setCount(0);

      window.dispatchEvent(new Event("notificationUpdated"));
    } catch (err) {
      console.log("❌ READ ALL ERROR:", err.response?.data || err.message);
    }
  }

// async function deleteNotification(id) {

//   if (deletingId === id) return;

//   setDeletingId(id);

//   try {
//     const res = await axios.delete(
//       `${BaseUrl}${BuyerServicesUrl.DeleteNotification}/${id}`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );

//     console.log("🗑 DELETE RESPONSE:", res.data);

//     setNotifications((prev) =>
//       prev.filter((item) => item.id !== id)
//     );

//     // setCount((prev) => (prev > 0 ? prev - 1 : 0));
// await getCount();


//     window.dispatchEvent(new Event("notificationUpdated"));

//   } catch (err) {
//     console.log("❌ DELETE ERROR:", err.response?.data || err.message);
//   } finally {
//     setDeletingId(null);
//   }
// }
async function deleteNotification(id) {
  if (deletingId === id) return;

  setDeletingId(id);

  try {
    const res = await axios.delete(
      `${BaseUrl}${SellerServicesUrl.SellerDeleteNotification}/${id}`,
      { headers: getAuthHeaders() }
    );

    console.log("🗑 DELETE RESPONSE:", res.data);

    setNotifications((prev) => prev.filter((item) => item.id !== id));

    await getCount();

    window.dispatchEvent(new Event("notificationUpdated"));

  } catch (err) {
    console.log("❌ DELETE ERROR:", err.response?.data || err.message);
  } finally {
    setDeletingId(null);
  }
}

  useEffect(() => {
    getNotifications();
    getCount();

    const handleUpdate = () => {
      getCount();
    };

    window.addEventListener("notificationUpdated", handleUpdate);

    return () => {
      window.removeEventListener("notificationUpdated", handleUpdate);
    };
  }, []);

  return (
    <div className="notifications-page mt-5 pt-5 pb-5 mb-5">
      <div className="notifications-header mt-5 pt-5 pb-5">
        <h2 className="mt-5">الإشعارات 🔔 ({count})</h2>
      </div>

      {notifications.length > 0 && (
        <button
          onClick={markAllAsRead}
          className="btn btn-primary mb-3 detect-btn"
        >
          تحديد الكل كمقروء ✔️
        </button>
      )}

      <div className="notifications-container">
        {loading ? (
          <p className="text-center mt-10">جاري التحميل...</p>
        ) : notifications.length === 0 ? (
          <p className="text-center mt-10 text-gray-500">
            🔕 لا يوجد إشعارات
          </p>
        ) : (
          notifications.map((item) => (
            <div className="notification-card" key={item.id}>
              <div className="notification-avatar">
                <img src={notifyIcon} alt="icon" />
              </div>

              <div className="notification-body">
                <h4>{item.title}</h4>
                <p>{item.message}</p>
                <span className="time">الآن</span>
              </div>

              <button
                className="delete-btn"
                onClick={() => deleteNotification(item.id)}
              >
                <i className="fa fa-trash  text-danger"></i>
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}